/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogoUseTypeModel } from '../../models/logo-use-type-model';

export interface LogoUseTypeIdGet$Params {
  id: string;
}

export function logoUseTypeIdGet(http: HttpClient, rootUrl: string, params: LogoUseTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LogoUseTypeModel>> {
  const rb = new RequestBuilder(rootUrl, logoUseTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<LogoUseTypeModel>;
    })
  );
}

logoUseTypeIdGet.PATH = '/LogoUseType/{id}';
